import React from "react";
import { useTranslation } from "react-i18next";
import { LANGUAGES } from "./i18n";

const LanguageSelector = ({ className }) => {
  const { t, i18n } = useTranslation();
  return (
    <select
      className={className}
      value={i18n.language?.split("-")[0] || "en"}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label={t("language")}
    >
      {LANGUAGES.map(({ code, label }) => (
        <option key={code} value={code}>{label}</option>
      ))}
    </select>
  );
};

export default LanguageSelector;
